import responseReader from '../store/readHelpers/ResponseReader';
import objectTypes from '../constants/ObjectTypes';
import flaggedItemsReader from '../store/readHelpers/FlaggedItemsReader';
import tocActions from '../actions/TocActions';
import questionSelectionService from './QuestionSelectionService';

function isNotAttempted(question) {
    const { contentRevisionId } = question;
    const itemResult = responseReader.getItemResultForQuestion(contentRevisionId);

    if (question.objectType === objectTypes.DOCUMENT || question.objectType === objectTypes.CONTENT_BLOCK) {
        return false;
    } else if (question.objectType === objectTypes.ORAL) {
        return !responseReader.isQuestionAttempted(question);
    } else if (!itemResult) {
        return true;
    }

    return !responseReader.isAtLeastOneInteractionRepliedTo(contentRevisionId);
}

export function checkFilterMatch(question, filter) {
    const { contentRevisionId } = question;

    if (filter === tocActions.filterTypes.NOT_ATTEMPTED) {
        return isNotAttempted(question);
    } else if (filter === tocActions.filterTypes.FLAGGED) {
        return flaggedItemsReader.isItemFlagged(contentRevisionId);
    }

    if (filter === tocActions.filterTypes.MANUALLY_SELECTED) {
        return questionSelectionService.isSelected(contentRevisionId);
    }

    if (filter === tocActions.filterTypes.MANUALLY_SELECTED_NOT_ATTEMPTED) {
        return questionSelectionService.isSelected(contentRevisionId) && isNotAttempted(question);
    }

    return true;
}

export function getFilteredListOfQuestions(sections, filter = tocActions.filterTypes.ALL) {
    return sections.reduce(
        (matchingSections, section, sectionIndex) => {
            // Get an array of matching questions (contentRevisionId).
            const questions = section.questions
                .map((question, questionIndex) => Object.assign({}, {
                    contentRevisionId: question.contentRevisionId,
                    sectionIndex,
                    questionIndex,
                }))
                .filter(question => checkFilterMatch(question, filter));

            if (questions.length) {
                matchingSections.push({ sectionIndex, questions });
            }

            return matchingSections;
        },
        [], // Initial value passed to the outer reducer function.
    );
}
